import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-file-list-3-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap">
                Sugargoo Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              The most comprehensive Sugargoo Spreadsheet resource hub. Helping shoppers discover, organize, and buy smarter since 2024.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Home</Link>
              </li>
              <li>
                <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Categories</a>
              </li>
              <li>
                <a href="#guides" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Shopping Guides</a>
              </li>
              <li>
                <a href="#articles" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">SEO Articles</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Main Website</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Top Articles</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/sugargoo-spreadsheet-ultimate-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Ultimate Guide</Link>
              </li>
              <li>
                <Link to="/article/sugargoo-spreadsheet-beginner-tutorial" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Beginner Tutorial</Link>
              </li>
              <li>
                <Link to="/article/sugargoo-review-2026" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Sugargoo Review</Link>
              </li>
              <li>
                <Link to="/article/sugargoo-shipping-cost-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Shipping Cost Guide</Link>
              </li>
              <li>
                <Link to="/article/is-sugargoo-legit-safety" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">Safety & Trust</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">Disclaimer</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              This is an independent educational resource. We are not affiliated with or endorsed by Sugargoo. All product links direct to our partner website.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {currentYear} sugargoosheet.autos. All rights reserved. Independent educational resource.
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-sm text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Home</a>
            <a href="/article/sugargoo-spreadsheet-ultimate-guide" className="text-sm text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Articles</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Main Site</a>
          </div>
        </div>
      </div>
    </footer>
  );
}